

import { enableBodyScroll } from "//auriccosmetics.com/cdn/shop/t/41/assets/body_scroll_lock.js?v=61507118286993660021756426367";

const SELECTORS = {
  MODAL_OPENED: 'modal-opened',
  IFRAME: '.modal__content iframe',
};

const iframes = [...document.querySelectorAll(SELECTORS.IFRAME)];
let sources = [];

if (iframes) {
  iframes.forEach(iframe => sources.push(iframe.getAttribute('src')));
}

export const preventDoubleTap = (() => {
  let doubleTouchStartTimestamp = 0;

  return event => {
    const now = Number(new Date());

    if (doubleTouchStartTimestamp + 500 > now) {
      event.preventDefault();
    }

    doubleTouchStartTimestamp = now;
  };
})();

export const isModalOpened = () => {
  return document.body.classList.contains(SELECTORS.MODAL_OPENED);
};

let scrollTop;

export const openModal = (element) => {
  const iframe = element.querySelector('iframe');

  if (!element.classList.contains('show')) {
    if (iframe.getAttribute('src') === '') {
      iframe.setAttribute('src', `${sources[iframes.indexOf(iframe)]}`);
    }
    element.classList.add('show');
    element.addEventListener('click', preventDoubleTap);
    scrollTop = $(document).scrollTop();
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `-${scrollTop}px`;
    document.body.classList.add(SELECTORS.MODAL_OPENED);
  }
};

export const closeModal = (element) => {
  const iframe = element.querySelector('iframe');

  if (element.classList.contains('show')) {
    element.classList.remove('show');
    enableBodyScroll(element);
    element.removeEventListener('click', preventDoubleTap);
    const body = document.body;
    body.style.removeProperty('position');
    window.scrollTo(0, scrollTop);
    body.classList.remove(SELECTORS.MODAL_OPENED);
    iframe.setAttribute('src', '');
  }
};
